const cartDrawerObserver = new MutationObserver(function(mutationList, observer) {
  for(const mutation of mutationList) {
    if(mutation.type == "attributes") {
      setTimeout(function() {
        BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false)
        BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
      }, 1000)
    }
  }
})

cartDrawerObserver.observe(document.querySelector("cart-drawer"), { attributes: true });
if(window.location.pathname === '/pages/b2b-registrierung'){
setTimeout(() => {
const elms = document.querySelectorAll("#RegisterForm .field, #bss-b2b-registration-form-render .form-group:not(.field-country-field)");
if(elms.length){
elms.forEach(item => {
const input = item.querySelector("input");
const label = item.querySelector("label");
if(input && label){
input.after(label);
input.placeholder = label.textContent;
}
})
}
}, 300)
  
}